import { hotRank } from "../../../mocks/trending";

export default function HotRank() {
  const [top, ...rest] = hotRank;

  return (
    <section id="rank" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-fire-line" /> 出圈短视频热门速递
            </span>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              实时热度排行榜
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600">
              依据全网真实讨论热度与传播速度综合排榜，越靠前越值得立刻点开，跟上吃瓜节奏不落伍。
            </p>
          </div>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-5">
          {/* TOP 1 highlight */}
          <article className="lg:col-span-2">
            <div className="group relative w-full overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative w-full overflow-hidden">
                <img
                  src={top.cover}
                  alt={`吃瓜爆网热度榜第一名：${top.title}`}
                  title={`${top.title} 吃瓜爆网热门短视频`}
                  className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
                <span className="font-heading absolute left-4 top-4 rounded-lg bg-secondary-500 px-3 py-1 text-sm font-black text-background-50">
                  TOP 1
                </span>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-xl font-bold leading-snug text-background-50">
                    {top.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-4 text-sm text-background-50/90">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" /> {top.views}
                    </span>
                    <span className="inline-flex items-center gap-1 text-accent-200">
                      <i className="ri-arrow-up-line" /> {top.trend}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* 2-6 list */}
          <ol className="flex flex-col gap-4 lg:col-span-3" aria-label="热度榜前六名">
            {rest.map((item, idx) => (
              <li key={item.id}>
                <a
                  href="#collections"
                  className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 hover:bg-background-100"
                >
                  <span
                    className={
                      "font-heading flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-base font-black " +
                      (idx === 0
                        ? "bg-secondary-100 text-secondary-800"
                        : "bg-background-100 text-foreground-400")
                    }
                  >
                    {idx + 2}
                  </span>
                  <div className="relative hidden h-14 w-20 shrink-0 overflow-hidden rounded-lg sm:block">
                    <img
                      src={item.cover}
                      alt={`吃瓜爆网热度榜第${idx + 2}名封面：${item.title}`}
                      title={`${item.title} 吃瓜爆网短视频`}
                      loading="lazy"
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="truncate text-sm font-semibold text-foreground-800 group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </h4>
                    <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-price-tag-3-line text-accent-600" />
                        {item.category}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-eye-line" /> {item.views}
                      </span>
                      <span className="inline-flex items-center gap-1 text-primary-600">
                        <i className="ri-arrow-up-line" /> {item.trend}
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-300 transition-colors group-hover:text-accent-600" />
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}